<div class="z-50 flex h-full flex-col">
  @if (messageService.trackingInfo()) {
    <div
      class="flex h-14 w-full flex-none flex-col justify-center rounded-xl bg-purple-700/50 px-3 text-normal !text-bo-white backdrop-blur-lg"
    >
      {{ messageService.trackingInfo() }}
    </div>
  }
  @if (messageService.currentMessage()) {
    <div
      class="flex h-14 w-full flex-none flex-col justify-center rounded-xl bg-bo-blue/50 px-3 text-normal !text-bo-white backdrop-blur-lg"
      [ngClass]="{
        'mt-2': messageService.trackingInfo(),
        'bg-bo-red/80': messageService.currentMessage()?.penalty,
      }"
    >
      {{ messageService.currentMessage()?.text }}
    </div>
  }
  @if (messageService.debugMessage()) {
    <div
      class="flex h-14 w-full flex-none flex-col justify-center rounded-xl bg-purple-700/50 px-3 text-normal !text-bo-white backdrop-blur-lg"
      [ngClass]="{
        'mt-2':
          messageService.currentMessage() || messageService.trackingInfo(),
      }"
    >
      {{ messageService.debugMessage() }}
    </div>
  }
  @if (expand()) {
    <div
      class="no-scrollbar h-full overflow-y-auto"
      [ngClass]="{ 'mt-2': messageService.currentMessage() }"
    >
      @for (message of messageService.messages(); track message) {
        <div
          class="mb-2 flex h-14 w-full flex-col justify-center rounded-xl bg-bo-accent-blue/70 px-3 text-normal !text-bo-white backdrop-blur-lg"
          [ngClass]="{
            'mt-2':
              messageService.currentMessage() || messageService.debugMessage(),
            'bg-bo-red/80': message?.penalty,
          }"
        >
          {{ message?.text }}
        </div>
      }
    </div>
  }
</div>
